import { type JSX, memo } from 'react';

import type { Bet, Odd } from '../../types';

import { OddsGridCell } from './OddsCell';

interface ExchangeOddsCellProps {
  bet: Bet;
  bookieCode: string;
  isBest: boolean;
  odds: Odd | undefined;
  oddsFormat?: string;
  oddsText: string | number | undefined;
}

const ExchangeOddsCellComponent = ({
  bet,
  bookieCode,
  isBest,
  odds,
  oddsFormat,
  oddsText,
}: ExchangeOddsCellProps): JSX.Element => {
  return (
    <OddsGridCell
      bet={bet}
      betName={bet.name}
      bookieCode={bookieCode}
      isBest={isBest}
      odds={odds}
      oddsFormat={oddsFormat}
      oddsText={oddsText}
    />
  );
};

export const ExchangeOddsCell = memo(ExchangeOddsCellComponent);
